export const onHomeworkUpdateSuccess = (data, get) => {
  get().updateHomework(data.homework);
};

export const onHomeworkScheduleSuccess = (data, get) => {
  const { newHomeworks = [], homeworksToDelete = [] } = data;
  for (const homework of newHomeworks) {
    get().updateHomework(homework);
  }
  for (const homework of homeworksToDelete) {
    get().removeHomework(homework);
  }
};
